import { CommonModule } from '@angular/common';
import {
  ChangeDetectionStrategy,
  Component,
  EventEmitter,
  Input,
  OnDestroy,
  OnInit,
  Output,
  TemplateRef,
  ElementRef,
  ViewChild,
  ChangeDetectorRef,
} from '@angular/core';
import { FormsModule } from '@angular/forms';
import { MatCheckbox, MatCheckboxModule } from '@angular/material/checkbox';
import { MatMenuModule } from '@angular/material/menu';
import { RxRoleGuardDirective } from '@org/rx-directives';
import { RxIconComponent } from '../../rx-icon/rx-icon.component';

@Component({
  selector: 'rx-list-photo-item',
  templateUrl: './rx-list-photo-item.component.html',
  styleUrls: ['./rx-list-photo-item.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [CommonModule, FormsModule, RxIconComponent, MatMenuModule, MatCheckboxModule],
})
export class RxListPhotoItemComponent {
  @Input()
  public enableDrag: boolean;

  @Output()
  public enableDragChange = new EventEmitter<boolean>();

  @Input()
  public hasCheckbox = true;

  @Input()
  public description;

  private _image: string;
  @Input()
  public get image(): string {
    return this._image;
  }
  public set image(value: string) {
    this._image = value;
  }

  @Input()
  public showMenuHandle = true;

  @Input()
  public actionMenu: any;

  @Input()
  public actionMenuContext: any;

  @Input()
  public width = 100;

  @Input()
  public height = 100;

  @Input()
  public disableMenu = false;

  @Input() id = 'item' + Math.random().toString(36).substring(2);

  // Checked two way binding
  @Output()
  public checkedChange = new EventEmitter<boolean>();

  @Input()
  public set checked(val) {
    if (this._checked === !!val) {
      return;
    }
    this._checked = !!val;
    this._cd.detectChanges();
  }

  public get checked() {
    return this._checked;
  }

  protected _checked = false;

  constructor(private _cd: ChangeDetectorRef) {}

  public ngOnInit() {}

  public ngOnDestroy() {}

  public checkedChanged(event) {
    event.preventDefault();
    event.stopPropagation();

    this._checked = !this._checked;

    this.checkedChange.emit(this._checked);
  }

  public onMenuClicked($event) {
    $event.preventDefault();
    $event.stopPropagation();
  }

  public onEnableDrag(state: boolean) {
    if (this.enableDrag !== state) {
      this.enableDrag = state;
      this.enableDragChange.emit(state);
    }
  }
}
